// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/cis_contract_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { VoltageClass } from "./occto_master_model_pb";
import { file_bffuser_v1_occto_master_model } from "./occto_master_model_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/cis_contract_model.proto.
 */
export const file_bffuser_v1_cis_contract_model: GenFile = /*@__PURE__*/
  fileDesc("CiNiZmZ1c2VyL3YxL2Npc19jb250cmFjdF9tb2RlbC5wcm90bxIKYmZmdXNlci52MSKNBgobSW1wb3J0Q2lzQ29udHJhY3RzUm93UmVzdWx0EhIKCnJvd19udW1iZXIYASABKAUSNwoGc3RhdHVzGAIgASgOMicuYmZmdXNlci52MS5JbXBvcnRDaXNDb250cmFjdHNSb3dTdGF0dXMSJAocc3VwcGx5X3BvaW50X3NwZWNpZmljX251bWJlchgDIAEoCRIqCgpzdGFydF9kYXRlGAQgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUgAiAEBEigKCWFyZWFfY29kZRgFIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlEhcKD2Npc190YXJpZmZfY29kZRgGIAEoCRIvCg12b2x0YWdlX2NsYXNzGAcgASgOMhguYmZmdXNlci52MS5Wb2x0YWdlQ2xhc3MSKAoIZW5kX2RhdGUYCCABKAsyES5nb29nbGUudHlwZS5EYXRlSAGIAQESMQoSZXhpc3RpbmdfYXJlYV9jb2RlGAkgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGUSIAoYZXhpc3RpbmdfY2lzX3RhcmlmZl9jb2RlGAogASgJEjgKFmV4aXN0aW5nX3ZvbHRhZ2VfY2xhc3MYCyABKA4yGC5iZmZ1c2VyLnYxLlZvbHRhZ2VDbGFzcxIxChFleGlzdGluZ19lbmRfZGF0ZRgMIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVIAogBARIWCg5lcnJvcl9tZXNzYWdlcxgNIAMoCRIgChNvd25lcl9idXNpbmVzc19jb2RlGA4gASgJSAOIAQESKQocZXhpc3Rpbmdfb3duZXJfYnVzaW5lc3NfY29kZRgPIAEoCUgEiAEBEh8KF2RlbGV0ZXNfYWN0aXZlX2NvbnRyYWN0GBAgASgIQg0KC19zdGFydF9kYXRlQgsKCV9lbmRfZGF0ZUIUChJfZXhpc3RpbmdfZW5kX2RhdGVCFgoUX293bmVyX2J1c2luZXNzX2NvZGVCHwodX2V4aXN0aW5nX293bmVyX2J1c2luZXNzX2NvZGUi4gEKGUltcG9ydENpc0NvbnRyYWN0c1N1bW1hcnkSFQoNbmV3X3Jvd19jb3VudBgBIAEoBRIZChFjaGFuZ2VkX3Jvd19jb3VudBgCIAEoBRIbChN1bmNoYW5nZWRfcm93X2NvdW50GAMgASgFEhkKEWRlbGV0ZWRfcm93X2NvdW50GAQgASgFEhcKD2Vycm9yX3Jvd19jb3VudBgFIAEoBRIXCg90b3RhbF9yb3dfY291bnQYBiABKAUSKQohYWN0aXZlX2NvbnRyYWN0X2RlbGV0ZWRfcm93X2NvdW50GAcgASgFIrcCChVFeHBvcnRDaXNDb250cmFjdHNSb3cSJAocc3VwcGx5X3BvaW50X3NwZWNpZmljX251bWJlchgBIAEoCRIoCglhcmVhX2NvZGUYAiABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRIXCg9jaXNfdGFyaWZmX2NvZGUYAyABKAkSLwoNdm9sdGFnZV9jbGFzcxgEIAEoDjIYLmJmZnVzZXIudjEuVm9sdGFnZUNsYXNzEiUKCnN0YXJ0X2RhdGUYBSABKAsyES5nb29nbGUudHlwZS5EYXRlEiMKCGVuZF9kYXRlGAYgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRIgChNvd25lcl9idXNpbmVzc19jb2RlGAcgASgJSACIAQFCFgoUX293bmVyX2J1c2luZXNzX2NvZGUqqwIKG0ltcG9ydENpc0NvbnRyYWN0c1Jvd1N0YXR1cxIvCitJTVBPUlRfQ0lTX0NPTlRSQUNUU19ST1dfU1RBVFVTX1VOU1BFQ0lGSUVEEAASJwojSU1QT1JUX0NJU19DT05UUkFDVFNfUk9XX1NUQVRVU19ORVcQARIrCidJTVBPUlRfQ0lTX0NPTlRSQUNUU19ST1dfU1RBVFVTX0NIQU5HRUQQAhItCilJTVBPUlRfQ0lTX0NPTlRSQUNUU19ST1dfU1RBVFVTX1VOQ0hBTkdFRBADEisKJ0lNUE9SVF9DSVNfQ09OVFJBQ1RTX1JPV19TVEFUVVNfREVMRVRFRBAEEikKJUlNUE9SVF9DSVNfQ09OVFJBQ1RTX1JPV19TVEFUVVNfRVJST1IQBUJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_bffuser_v1_occto_master_model, file_google_type_date]);

/**
 * ImportCisContractsRowResult は取込行 1 行の結果 (プレビュー / 確定共通)。
 *
 * CSV は backend がパースするため (ImportCisContractsRequest.content = bytes)、
 * frontend は行データを一切持たない。差分プレビュー表を描くのに必要な値
 * (CSV 側の新値 + 既存側の旧値) はすべて本 message が返す
 * (common.md「変更行は 変更前 → 変更後 をインラインで表示」「削除行は削除対象の
 * 既存値をインラインで表示」)。
 *
 * @generated from message bffuser.v1.ImportCisContractsRowResult
 */
export type ImportCisContractsRowResult = Message<"bffuser.v1.ImportCisContractsRowResult"> & {
  /**
   * CSV 上の行番号 (1 始まり、ヘッダー行を除く)。エラー文言の「行 N」と一致する。
   *
   * @generated from field: int32 row_number = 1;
   */
  rowNumber: number;

  /**
   * @generated from field: bffuser.v1.ImportCisContractsRowStatus status = 2;
   */
  status: ImportCisContractsRowStatus;

  /**
   * 主キー (供給地点コード, 開始日)。ERROR 行でもパースできた分は埋める。
   *
   * @generated from field: string supply_point_specific_number = 3;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: optional google.type.Date start_date = 4;
   */
  startDate?: Date;

  /**
   * CSV 側の値 (= 変更後)。ERROR 行では未設定のことがある。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 5;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string cis_tariff_code = 6;
   */
  cisTariffCode: string;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 7;
   */
  voltageClass: VoltageClass;

  /**
   * 終了日。9999-12-31 は「契約終了日未定」のセンチネル (spec L83)。
   *
   * @generated from field: optional google.type.Date end_date = 8;
   */
  endDate?: Date;

  /**
   * 既存値 (= 変更前)。CHANGED / DELETED 行のみ設定。
   *
   * @generated from field: bfftypes.v1.AreaCode existing_area_code = 9;
   */
  existingAreaCode: AreaCode;

  /**
   * @generated from field: string existing_cis_tariff_code = 10;
   */
  existingCisTariffCode: string;

  /**
   * @generated from field: bffuser.v1.VoltageClass existing_voltage_class = 11;
   */
  existingVoltageClass: VoltageClass;

  /**
   * @generated from field: optional google.type.Date existing_end_date = 12;
   */
  existingEndDate?: Date;

  /**
   * ERROR 時のみ非空 (backend 生成の日本語文言)。
   *
   * @generated from field: repeated string error_messages = 13;
   */
  errorMessages: string[];

  /**
   * 事業者コード (決定16 の optional 8 列目、OCCTO 4 桁)。CSV 側の値 (= 変更後、
   * resolveOwnerBusinessCode を通した解決後の値)。Mirrors
   * internalapi.v1.ImportCisContractsRowResult.owner_business_code (doc 参照)。
   * unset = 帰属未整備。
   *
   * @generated from field: optional string owner_business_code = 14;
   */
  ownerBusinessCode?: string;

  /**
   * 既存の事業者コード (= 変更前)。CHANGED / DELETED 行のみ設定。unset = 帰属未整備。
   *
   * @generated from field: optional string existing_owner_business_code = 15;
   */
  existingOwnerBusinessCode?: string;

  /**
   * 削除行 (DELETED) のうち契約期間中の行 = 既存レコードの終了日がチェック日以降
   * (終了日未定のセンチネル 9999-12-31 を含む)。「チェック日」は backend が取込を
   * 処理した時刻の日本時間の日付で、dry_run と確定の再検証で同じ規則で求める。
   * DELETED 以外の行は常に false (spec supply-point-master.md AC-DUI-019 / 020)。
   *
   * @generated from field: bool deletes_active_contract = 16;
   */
  deletesActiveContract: boolean;
};

/**
 * Describes the message bffuser.v1.ImportCisContractsRowResult.
 * Use `create(ImportCisContractsRowResultSchema)` to create a new message.
 */
export const ImportCisContractsRowResultSchema: GenMessage<ImportCisContractsRowResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_cis_contract_model, 0);

/**
 * ImportCisContractsSummary は取込全体のサマリ
 * (common.md 鉄則1: 確定ダイアログ / プレビュー表示の SoT)。
 *
 * unchanged_row_count は件数のみで、対応する row_results 要素は返さない
 * (NFR 10 万行のレスポンスサイズ対策)。
 *
 * @generated from message bffuser.v1.ImportCisContractsSummary
 */
export type ImportCisContractsSummary = Message<"bffuser.v1.ImportCisContractsSummary"> & {
  /**
   * @generated from field: int32 new_row_count = 1;
   */
  newRowCount: number;

  /**
   * @generated from field: int32 changed_row_count = 2;
   */
  changedRowCount: number;

  /**
   * @generated from field: int32 unchanged_row_count = 3;
   */
  unchangedRowCount: number;

  /**
   * @generated from field: int32 deleted_row_count = 4;
   */
  deletedRowCount: number;

  /**
   * @generated from field: int32 error_row_count = 5;
   */
  errorRowCount: number;

  /**
   * CSV の総データ行数 (ヘッダー行を除く)。row_results が非据え置き行のみに
   * 間引かれるため、画面が「N 行中 M 行を表示」を出す母数として必要。
   *
   * @generated from field: int32 total_row_count = 6;
   */
  totalRowCount: number;

  /**
   * deleted_row_count のうち deletes_active_contract が true の行数
   * (AC-DUI-019 の警告バナーと AC-DUI-020 の確認ダイアログの {N})。
   *
   * @generated from field: int32 active_contract_deleted_row_count = 7;
   */
  activeContractDeletedRowCount: number;
};

/**
 * Describes the message bffuser.v1.ImportCisContractsSummary.
 * Use `create(ImportCisContractsSummarySchema)` to create a new message.
 */
export const ImportCisContractsSummarySchema: GenMessage<ImportCisContractsSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_cis_contract_model, 1);

/**
 * ExportCisContractsRow is one CSV row of 入稿済みデータのダウンロード
 * (uploads/common.md §6, AC-DUC-028/029)。Mirrors
 * internalapi.v1.ExportCisContractsRow。
 *
 * @generated from message bffuser.v1.ExportCisContractsRow
 */
export type ExportCisContractsRow = Message<"bffuser.v1.ExportCisContractsRow"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string cis_tariff_code = 3;
   */
  cisTariffCode: string;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 4;
   */
  voltageClass: VoltageClass;

  /**
   * @generated from field: google.type.Date start_date = 5;
   */
  startDate?: Date;

  /**
   * 9999-12-31 は契約終了日未定のセンチネル (supply-point-master.md §1 列フォーマット)。
   *
   * @generated from field: google.type.Date end_date = 6;
   */
  endDate?: Date;

  /**
   * 事業者コード (決定16 の optional 8 列目、OCCTO 4 桁)。unset = 帰属未整備。
   *
   * @generated from field: optional string owner_business_code = 7;
   */
  ownerBusinessCode?: string;
};

/**
 * Describes the message bffuser.v1.ExportCisContractsRow.
 * Use `create(ExportCisContractsRowSchema)` to create a new message.
 */
export const ExportCisContractsRowSchema: GenMessage<ExportCisContractsRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_cis_contract_model, 2);

/**
 * ImportCisContractsRowStatus は取込行 1 行の判定結果を表す
 * (common.md §Step2 差分判定の 5 ステータス)。
 *
 * @generated from enum bffuser.v1.ImportCisContractsRowStatus
 */
export enum ImportCisContractsRowStatus {
  /**
   * @generated from enum value: IMPORT_CIS_CONTRACTS_ROW_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 主キーが既存に存在しない (delete=1 以外)。
   *
   * @generated from enum value: IMPORT_CIS_CONTRACTS_ROW_STATUS_NEW = 1;
   */
  NEW = 1,

  /**
   * 主キー一致するが 終了日 / 事業者コード のいずれかが異なる (エリア / 契約種別コード / 電圧階級 の違いは ERROR、AC-DUI-016)。
   *
   * @generated from enum value: IMPORT_CIS_CONTRACTS_ROW_STATUS_CHANGED = 2;
   */
  CHANGED = 2,

  /**
   * 主キー + 比較列が完全一致 (据え置き)。
   *
   * @generated from enum value: IMPORT_CIS_CONTRACTS_ROW_STATUS_UNCHANGED = 3;
   */
  UNCHANGED = 3,

  /**
   * delete=1 かつ主キーが既存に存在する (論理削除対象、AC-DUI-010)。
   *
   * @generated from enum value: IMPORT_CIS_CONTRACTS_ROW_STATUS_DELETED = 4;
   */
  DELETED = 4,

  /**
   * 行エラー (確定不可、AC-DUI-002〜006 / 008 / 009)。
   *
   * @generated from enum value: IMPORT_CIS_CONTRACTS_ROW_STATUS_ERROR = 5;
   */
  ERROR = 5,
}

/**
 * Describes the enum bffuser.v1.ImportCisContractsRowStatus.
 */
export const ImportCisContractsRowStatusSchema: GenEnum<ImportCisContractsRowStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_cis_contract_model, 0);

